import React from "react";
import { motion } from "framer-motion";
import "./tools.css";

import one from "../../assets/company logo/f1.png";
import two from "../../assets/company logo/f4.jpg";
import three from "../../assets/company logo/ks.jpeg";
import four from "../../assets/company logo/newsky.jpeg";
import five from "../../assets/company logo/nsp.jpeg";
import six from "../../assets/company logo/zuari.jpeg";
import seven from "../../assets/company logo/tripp.jpg";
import eight from "../../assets/company logo/rediteee.jpeg";



const clients = [
  { src: one, alt: "Apache JMeter" },
  { src: two, alt: "Appium" },
  { src: three, alt: "Appium JPG" },
  { src: four, alt: "Cucumber" },
  { src: five, alt: "Java" },
  { src: six, alt: "Jenkins" },
  { src: seven, alt: "JUnit" },
  { src: eight, alt: "LoadRunner" },

];


function Tools() {
  return (
    <>
      <section className="our-clients-section">

        <section className="section-margin">
          <div className="heading-for-all" data-aos="fade-up">
            <h2>Our Clients</h2>
          </div>
        </section>



        <section className="our-clients-section">
          <div className="our-clients-container">
            {/* Motion Scroll (infinite loop) */}
            <motion.div
              className="our-clients-track"
              animate={{ x: ["0%", "-100%"] }}
              transition={{
                ease: "linear",
                duration: 100,
                repeat: Infinity,
              }}
            >
              {[...clients, ...clients].map((client, i) => (
                <div className="client-item" key={i}>
                  <img src={client.src} alt={client.alt} />
                </div>
              ))}
            </motion.div>
          </div>
        </section>
      </section>
    </>
  );
}

export default Tools;
